import Member from '@@types/Member';
import MemberLang from '@@types/MemberLang';

import { MemberStatus } from '~/constants';
import { MINUTE } from '~/constants/date';
import GA from '~/services/GA/GA';
import WebsocketConnector from '~/services/WebsocketConnector';
import Actions from '~/stores/Actions';
import { channelMembersLangStore } from '~/stores/ChannelMembersLangStore';
import { membersStore } from '~/stores/MembersStore';
import { userStore } from '~/stores/UserStore';

class MemberMessageHandler {
  constructor(protected ws: WebsocketConnector, protected actions: Actions) {}

  handleLocalStatus = (status: MemberStatus) => {
    membersStore.onResponseMemberStatus({
      type: 'memberStatus',
      action: 'local',
      content: status,
    });
    this.actions.userActions.updateLocalStatus(status);
  };

  handleStatusUpdate = ({ memberId, memberStatus }) => {
    if (memberId === userStore.id) return;
    membersStore.updateStatus({
      id: memberId,
      status: memberStatus,
    });
    delete membersStore.statusDelay[memberId];
    Object.keys(membersStore.statusDelay).filter((memberId) => {
      if (membersStore.statusDelay[memberId] > Date.now() + 5 * MINUTE) {
        delete membersStore.statusDelay[memberId];
        GA.writeStatusSlow(memberId);
      }
    });
  };

  handleUpdate = (member: Member) => {
    membersStore.updateMember(member);
    if (member.id === userStore.id) {
      userStore.setTimezone(member.timezoneName);
      this.actions.officeHoursActions.revalidateMeInWork();
    }
    this.actions.officeHoursActions.revalidateChannelNotInWork();
  };

  handleUpdateLang = (memberLang: MemberLang) => {
    channelMembersLangStore.update(memberLang);
  };
}

export default MemberMessageHandler;
